module.exports = __webpack_public_path__ + "img/settings.a0774d4b.svg";